







import echarts from 'vue-echarts'
import {Component} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {
	GetDlyDayCountStatistics,
	GetDlyMonthCountStatistics,
	GetDlyYearStatistics
} from "@/api/report"

@Component({
	components: {echarts}
})
export default class Age extends AbpBase {
	labelOption = {
		normal: {
			show: true,
			position: 'insideBottom',
			distance: 15,
			align: 'left',
			verticalAlign: 'middle',
			rotate: 90,
			formatter: '{c}  {name|{a}}',
			fontSize: 16,
			rich: {
				name: {
					textBorderColor: '#fff'
				}
			}
		}
	}
	echartsData:any = {
		color: ['#003366', '#006699', '#4cabce', '#e5323e'],
		tooltip: {
			trigger: 'axis',
			axisPointer: {
				type: 'shadow'
			}
		},
		legend: {
			data: []
		},
		toolbox: {
			show: true,
			orient: 'vertical',
			left: 'right',
			top: 'center',
			feature: {
				mark: {show: true},
				dataView: {show: true, readOnly: false},
				magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
				restore: {show: true},
				saveAsImage: {show: true}
			}
		},
		calculable: true,
		xAxis: [
			{
				type: 'category',
				axisTick: {show: false},
				data: []
			}
		],
		yAxis: [
			{
				type: 'value'
			}
		],
		series: []
	}
	loading = false
	data: any = []
	columns:any = []
	created() {
		this.getData()
	}
	private async getData() {
		this.loading = true
		const date = new Date()
		let res = await GetDlyDayCountStatistics({yearType: date.getFullYear(),monthType:date.getMonth()+1})
		let series:any = {}
		if (res.objects.typeItem && res.objects.typeItem.length) {
			this.echartsData.legend.data = res.objects.typeItem
			this.columns = [
				{
					title: "月份",
					key: 'date'
				},
			]
			res.objects.typeItem.forEach((item:any) => {
				this.columns.push({
					title: item.type,
					key: item.type
				})
				series[item.type] = {
					name: item.type,
					type: 'bar',
					barGap: 0,
					label: this.labelOption,
					data: []
				}
			})
			this.columns.push({title: "总计", key: 'total'})
		}
		if (res.objects.dlyItem && res.objects.dlyItem.length) {
			let xAxisData:any = []
			res.objects.dlyItem.forEach((item: any) => {
				xAxisData.push(item.date)
				item.dlyItems.forEach((d:any) => {
					item[d.type] = d.count
					series[d.type].data.push(d.count)
				})
			})
			this.echartsData.xAxis[0].data = xAxisData
		}
		this.echartsData.series = Object.values(series)
		this.data = res.objects.dlyItem || []
		this.loading = false
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/report/dialysisStatistics/parts/month.vue